export const CodesCompetence = {
  GT: 'GT',
  AODE: 'AODE',
  EPT: 'EPT',
  PNR: 'PNR',
  CSCE: 'CSCE',
};
